import { Color } from '@coast/schemas';
import { Tag } from '@shared/components/Tag';
import { Pill } from '@shared/components/pill';
import { TagField } from '@shared/data/entity/fields/TagField';
import { Colors } from '@shared/styles';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

const MAX_TAGS_TO_SHOW = 3;

interface Props {
  field: TagField;
}

export function TagCollectionViewField({ field }: Props) {
  if (field.isEmpty) {
    return null;
  }

  const visibleTagValues = field.tagIds.slice(0, MAX_TAGS_TO_SHOW);
  const remainingTagCount = field.tagIds.length - visibleTagValues.length;
  const visibleTags = field.tagOptions.filter(tag => visibleTagValues.includes(tag.value));

  return (
    <CardCollectionViewFieldContainer fieldType={field.fieldType}>
      {visibleTags.map(tag => (
        <Tag
          key={tag.value}
          color={tag.backgroundColor as Color}
          archived={!!tag.archived}
          label={tag.label}
        />
      ))}
      {remainingTagCount > 0 && (
        <Pill
          round
          noBorder
          backgroundColor={Colors.v2.transparent as Color}
          sections={[`+${remainingTagCount}`]}
        />
      )}
    </CardCollectionViewFieldContainer>
  );
}
